export default __webpack_public_path__ + "static/media/hans-klein.3a8ce7cd.gif";